export default __webpack_public_path__ + "static/AzoSansItalic-9756bfe87bf6248b0f447c08e97d716f.woff2";